module.exports = "/src/views/assets/images/logo.png";